import AcSelect from 'components/AcSelect/AcSelect';
import { CheckoutThemeFormValues } from '../../types';
import { EAssetType } from 'constants/enums';
import { UploadsTooltips } from 'hooks/useUpload';
import { Flex } from 'components/ui/flex';
import { Typography } from '@mui/material';
import { FocusEventHandler } from 'react';

const Logo = ({
  defaultValues,
  pictures,
  setFieldValue,
  handleChange,
  handleBlur,
  touched,
  errors
}: {
  defaultValues: CheckoutThemeFormValues;
  pictures: any;
  setFieldValue: (field: string, value: any) => void;
  handleChange: (e: any) => void;
  handleBlur: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  touched: any;
  errors: any;
}) => {
  return (
    <AcSelect
      header="Logo"
      name="logo"
      value={defaultValues.logo}
      dataTestBoxId="checkoutLogo"
      uploadBtnTestId="uploadCheckoutLogo"
      dataTestListId="checkoutLogoList"
      optionDataTestIdPrefix="checkoutLogoOption"
      uploadConfig={{
        onUploadSuccess: async (url: string) => {
          await pictures.refetch();
          setFieldValue('checkout.logo', url);
        },
        uploadType: EAssetType.LOGO,
        uploadMessage: UploadsTooltips[EAssetType.LOGO]
      }}
      items={[
        {
          content: 'Default Appcharge logo',
          key: 'https://media.appcharge.com/defaults/default-store-logo.svg',
          value: 'https://media.appcharge.com/defaults/default-store-logo.svg',
          renderFunction: () => {
            return (
              <Flex direction="row" align="center" className="gap-2">
                <img
                  src="https://media.appcharge.com/defaults/default-store-logo.svg"
                  alt="Default Appcharge logo"
                  style={{
                    maxWidth: 26
                  }}
                />
                <Typography>Default Appcharge logo</Typography>
              </Flex>
            );
          }
        },
        ...(pictures.data || [])
          .filter((p: any) => p.type === EAssetType.LOGO)
          .map((picture: any) => {
            return {
              content: picture.name,
              key: picture.url,
              value: picture.url,
              renderFunction: () => {
                return (
                  <Flex direction="row" align="center" className="gap-2">
                    <img
                      src={picture.url}
                      alt={picture.name}
                      style={{
                        width: 26,
                        maxHeight: 30
                      }}
                    />
                    <Typography>{picture.name}</Typography>
                  </Flex>
                );
              }
            };
          })
      ]}
      onChange={handleChange}
      onBlur={handleBlur}
      error={touched.logo && Boolean(errors.logo)}
      tooltip="This will be the logo of your checkout."
    />
  );
};

export default Logo;
